import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import PaiSidebar from "../../components/PaiSidebar";
import Task from "./Task";
import CodeEditor from "./CodeEditor";
import NextTaskButton from "./NextTask";
import "./MainTask.css";
import fetchProtectedData from "../auth/ProtectDataHeader";
import withTokenRefresh from "../auth/RefreshToken";
import ReactGA from "react-ga4";

ReactGA.send({
  hitType: "pageview",
  page: "/practice",
  title: "Просмотрели страницу с практикой",
});

function MainTask() {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [topicFront, setTopicFront] = useState(null);
  const [taskData, setTaskData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [user_id, setUserId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [code, setCode] = useState(`# Пиши свой код сюда`);
  const [conversation, setConversation] = useState([]);

  const queryParams = new URLSearchParams(location.search);
  const topicFromURL = queryParams.get("topic");
  const selectedCourse = queryParams.get('course_name') || '';

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const protectedData = await withTokenRefresh(fetchProtectedData);
        setUserId(protectedData);
        if (!protectedData) {
          navigate("/login");
          return;
        }

        const SUB_ENDPOINT = `/api/subscription/?user_id=${protectedData}`;
        const subscriptionResponse = await fetch(SUB_ENDPOINT, {
          method: "GET",
          headers: { Accept: "application/json" },
        });
        const subscriptionData = await subscriptionResponse.json();
        if (subscriptionData.status === "expired") {
          navigate("/courses");
        }
      } catch (err) {
        navigate("/login");
        return;
      }
    };
    fetchData();
  }, [navigate]);

  useEffect(() => {
    if (topicFromURL && user_id) {
      handleThemeSelect(topicFromURL);
    }
  }, [user_id, topicFromURL, navigate]);

  const fetchTasks = async (topic) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `/api/tasks/unresolved?user_id=${user_id}&topic=${topic}&course_name=${selectedCourse}`,
        {
          method: "GET",
          headers: { Accept: "application/json" },
        }
      );

      if (!response.ok) {
        if (response.status === 404) {
          setError("Не осталось задач в топике");
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return;
      }

      const data = await response.json();
      console.error("data", data);
      setTaskData(data);
      setTopicFront(data.topic_front);
    } catch (err) {
      setError(err.message);
      setTaskData(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchTaskByTheme = async (theme) => {
    await fetchTasks(theme);
  };

  const fetchNextTask = async () => {
    if (!selectedTopic) {
      setError("Тематика не выбрана");
      return;
    }
    await fetchTasks(selectedTopic);
  };

  const handleThemeSelect = (theme) => {
    setSelectedTopic(theme);
    fetchTaskByTheme(theme);
  };

  return (
    <div className="app">
      <Header />
      <main className={`main-task-content ${isSidebarOpen ? "shifted" : ""}`}>
        <Task
          user_id={user_id}
          topicFront={topicFront}
          taskData={taskData}
          loading={loading}
          error={error}
          onSelectTheme={handleThemeSelect}
          onTaskDataUpdate={setTaskData}
          course_name={selectedCourse}
        />
        <CodeEditor
          taskData={taskData}
          code={code}
          setCode={setCode}
          course_name={selectedCourse}
          user_id={user_id}
        />
        {selectedTopic && (
          <NextTaskButton
            onClick={fetchNextTask}
            loading={loading}
          />
        )}
        {taskData && (
          <PaiSidebar
            user_id={user_id}
            topic={taskData.topic}
            task_number={taskData.task_number}
            is_task={true}
            user_code={code}
            conversation={conversation}
            setConversation={setConversation}
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
            course_name={selectedCourse}
          />
        )}
      </main>
    </div>
  );
}

export default MainTask;
